import React from "react";
import styled from "styled-components";
import logo from './Assets/NGHS_Logo.png'

const Div = styled.div`
    max-width: 95%;
    margin: 0 auto;
    display: flex;
    flex-direction: column;
    background: white;
    padding: 2% 0;
    margin-top: 1rem;
    margin-bottom: 5%;
    @media (min-width: ${props => props.theme.mobileBreakpoint}){
        max-width: 80%;
    }
    @media (min-width: ${props => props.theme.tabletBreakpoint}){
        max-width: 50%;
    }
`

const LOGO = styled.img`
    width: 30%;
    height: 30%;
    align-self: center;
    margin-bottom: 1rem;
    margin-top: 1rem;

    @media (min-width: ${props => props.theme.mobileBreakpoint}){
        width: 15%;
        height: 15%;
    }
    @media (min-width: ${props => props.theme.tabletBreakpoint}){
        max-width: 80%;
    }
`

const P = styled.p`
    font-size: 1.1rem;
`

const About = () => {

    return(
        <Div>
            <LOGO src={logo} alt="NGHSEC Logo"></LOGO>
            <h5>Our Mission Statement</h5>
            <P>The purpose of NG environmental club is to spread awareness about environmental conservation 
                efforts and promote environmentally conscious practices within our day to day life. The goal 
                is to inform members of the latest environmental issues and instill conscious habits to combat 
                these issues. Our club strives to spread awareness and fundraise money to donate to environmental 
                charities & research.</P>
            <br/>
            <h5>Topics and Activities</h5>
            <P>We will be discussing issues such as climate change, how to reduce our waste, environmentally friendly 
                substitutes, fast fashion, and ocean microplastics. Volunteer opportunities include trash pickup events, removal of invasive plant species, eco-bricks, and 
                drop-box donations. </P>
            {/* <img src={""} alt="NGHSEC Logo"></img> */}
            {/* <a>Volunteer opportunities include trash pickup events, removal of invasive plant species, eco-bricks, and 
                drop-box donations. </a> */}
        </Div>
    )
}

export default About;